var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-app"},[_c('TheSidebar',{ref:"sidebar"}),_c('div',{staticClass:"c-wrapper"},[_c('TheHeader'),_c('div',{staticClass:"c-body"},[_c('b-overlay',{staticClass:"w-100",attrs:{"opacity":"0.75","variant":"light","show":_vm.mainLoading}},[_c('main',{staticClass:"c-main h-100"},[_c('b-container',{class:[
              _vm.$route.name === 'Report Customer Detail'
                ? 'report_customer_detail'
                : '',
            ],attrs:{"fluid":""}},[_c('router-view'),_c('Loading')],1)],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }